<template lang="html">
  <section class="app-sidebar"  v-if="rolHeader.modulos && usuario" >
    {{ tieneAvisoPixan }}
    <nav 
    :class="{'active': 
      this.sliderMovil,
      'sidebar': true,
      'sidebar-offcanvas': true}"
    id="sidebar">
      <ul class="nav">
        
        <li class="nav-item pointer" v-if="rolHeader.modulos.catalogos.accesos">
          <span class="nav-link" v-b-toggle="'table-dropdown'">
            <i class="menu-icon mdi mdi-package-variant-closed"></i>
            <span class="menu-title">Cátalogos</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse id="table-dropdown">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/Productos">Productos</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/Servicios">Servicios</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/Colores">Colores</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/Especies">Especies</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/estudios">Estudios</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/espacios">Espacios</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/cajas">Cajas</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/formatos">Formatos</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/almacenes">Almacenes</router-link>
              </li>
              <li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" to="/unidades">Unidades</router-link>
              </li>
              <!--<li class="nav-item" @click="cerrarSliderMovil()">
                <router-link class="nav-link" :to="{name:'categorias'}">Categorías gastos</router-link>
              </li>-->
            </ul>
          </b-collapse>
        </li>
        
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.propietarios.accesos">
          <router-link 
           id="propietarioTest"
          :class="{'active': 
          this.$route.name == 'propietario' || 
          this.$route.name == 'propietarioNuevo',
          'nav-link': true}"
          to="/propietarios" >
            <i class="menu-icon mdi mdi mdi mdi-account-location"></i>
            <span class="menu-title">Propietarios</span>
          </router-link>
        </li>

        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.pacientes.accesos">
          <router-link
           id="pacienteTest"
          :class="{'active': 
          this.$route.name == 'paciente_nuevo' || 
          this.$route.name == 'paciente_nuevo_con_propietario' || 
          this.$route.name == 'paciente_editar',
          'nav-link': true}" 
          to="/pacientes">

            <i class="menu-icon mdi mdi mdi mdi-paw"></i>
            <span class="menu-title">Pacientes</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.pacientes.casos.consultar" >
          <router-link class="nav-link" to="/casos">
            
            <i class="menu-icon mdi mdi-clipboard-text"></i>
          
            <span   id="casoClinicoTest" class="menu-title">Casos clínicos</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.ventas_mostrador.accesos">
          <router-link  class="nav-link" to="/venta_mostrador"  id="ventaMostrador">
            <i class="menu-icon mdi mdi-clipboard-text"></i>
           
            <span class="menu-title">Venta mostrador</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.agenda.accesos">
          <router-link class="nav-link" to="/agenda">
            <i class="menu-icon mdi mdi mdi mdi-calendar-text"></i>
            <span class="menu-title">Agenda</span>
          </router-link>
        </li>
        <li class="nav-item pointer" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.sala_espera.accesos">
          <a class="nav-link" @click="abrirBoard()">
            <i class="menu-icon mdi mdi mdi mdi-format-list-bulleted"></i>
            <span class="menu-title">Sala de espera</span>
          </a>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.cortes_caja.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'corte_editar',
          'nav-link': true}" 
          to="/cortes_caja">

            <i class="menu-icon fa fa-money"></i>
            <span class="menu-title">Cortes de caja</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.descuentos.accesos">
          <router-link class="nav-link" to="/descuentos">
            <i class="menu-icon fa fa-tag"></i>
            <span class="menu-title">Descuentos</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.planes_bienestar.accesos">
          <router-link 
          v-if="usuario.estatus_pago.plan !== '001'"
          :class="{'active': 
          this.$route.name == 'plan_bienestar_editar' || 
          this.$route.name == 'plan_bienestar',
          'nav-link': true}"  
          to="/planes_bienestar">
          
            <i class="menu-icon mdi mdi mdi mdi-emoticon-happy"></i>
            <span class="menu-title">Planes de bienestar</span>
          </router-link>

          
          <a v-else data-v-59415ddb58="" href="#" @click="onNecesitaPremium()" class="nav-link">
          <i data-v-59415b58="" class="menu-icon mdi mdi mdi mdi-emoticon-happy"></i> 
          <span data-v-59415b58="" class="menu-title">Planes de bienestar</span></a>

        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.corporativo.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'Corporativo_info' || 
          this.$route.name == 'Sucursal' || 
          this.$route.name == 'SucursalNuevo' || 
          this.$route.name == 'Sucursales',
          'nav-link': true}" 
          to="/corporativo">

            <i class="menu-icon mdi mdi mdi mdi-hospital-building"></i>
            <span class="menu-title">Corporativo</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.proveedores.accesos">
          <router-link to="/proveedores" class="nav-link" >
            <i class="menu-icon fa fa-truck"></i>
            <span class="menu-title">Proveedores</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.compras.accesos">
          <router-link to="/compras" class="nav-link" >
            <i class="menu-icon fa fa-shopping-cart"></i>
            <span class="menu-title">Compras</span>
          </router-link>
        </li>
        <!--<li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.compras.accesos">
          <router-link to="/gastos" class="nav-link" >
            <i class="menu-icon fa fa-shopping-cart"></i>
            <span class="menu-title">Gastos</span>
          </router-link>
        </li>-->
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.inventarios.accesos">
          <router-link to="/inventarios" class="nav-link" >
            <i class="menu-icon fa  fa-check-square-o"></i>
            <span class="menu-title">Inventarios</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.usuarios.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'usuario' || 
          this.$route.name == 'usuarioNuevo',
          'nav-link': true}"
          to="/usuarios">
            <i class="menu-icon mdi mdi mdi mdi-account-circle"></i>
            <span class="menu-title">Colaboradores</span>
          </router-link>
        </li>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.roles.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'rol_nuevo' || 
          this.$route.name == 'rol_editar',
          'nav-link': true}" 
          to="/roles">
            <i class="menu-icon mdi mdi mdi mdi-account-key"></i>
            <span class="menu-title">Roles</span>
          </router-link>
        </li>
        <template v-if="rolHeader.modulos.vencimientos">
          <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.vencimientos.accesos">
            <router-link 
            class="nav-link" 
            to="/vencimientos">
              <i class="menu-icon mdi mdi mdi mdi-alert-circle"></i>
              <span class="menu-title">Vencimientos</span>
            </router-link>
          </li>
        </template>
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.reportes.accesos">
          <router-link class="nav-link" to="/reportes">
            <i class="menu-icon mdi mdi mdi mdi-chart-line"></i>
            <span class="menu-title">Reportes</span>
          </router-link>
        </li>
        <li class="nav-item mb-md-4" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.reportes.accesos">
          <router-link class="nav-link" to="/reportes3">
            <i class="menu-icon mdi mdi mdi mdi-chart-line"></i>
            <span class="menu-title">Reportes V2</span>
          </router-link>
        </li>
       <!-- <li class="nav-item mb-md-4" @click="cerrarSliderMovil()" v-if="rolHeader.modulos.reportes.accesos">
          <router-link class="nav-link" to="/reportes2">
            <i class="menu-icon mdi mdi mdi mdi-chart-line"></i>
            <span class="menu-title">Otros resportes</span>
          </router-link>
        </li>  -->
      </ul>
    </nav>
  </section>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from "vuex";
import JQuery from 'jquery'
// eslint-disable-next-line
let $ = JQuery
export default {
  name: 'app-sidebar',
  mounted () {
    
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseenter', function () {
      var $this = $(this)
      $this.addClass('hover-open')
      $this.find('.nav-link').addClass('hover-open')
    })
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseleave', function () {
      var $this = $(this)
      $this.removeClass('hover-open')
      $this.find('.nav-link').removeClass('hover-open')
    })
  },
  data(){
    return{
      sliderMovil: false
    }
  },
  created() {
    
  },
  watch: {
    
  },
  computed: {
    ...mapGetters(["rolHeader", 'usuario']),
    tieneAvisoPixan(){
      
    }
   
  },
  methods: {
    ...mapActions(['modalCargandoAviso', 'actualizarUsuario']),
    cerrarSliderMovil(){
      $('#sidebar').toggleClass('active')
    },
    abrirBoard() {   
        const nombreServidor = document.location.hostname;
        console.log("TCL: abrirBoard -> nombreServidor", nombreServidor)
        if(nombreServidor == 'localhost'){
          window.open("http://localhost:8080/#/board", "_blank");
        }else{
          if(nombreServidor == 'test.pixancloud.com'){
            window.open("http://test.pixancloud.com/#/board", "_blank");
          }
          else if(nombreServidor == 'app2.pixancloud.com'){
            window.open("http://app2.pixancloud.com/#/board", "_blank");
          }else{
            window.open("http://app.pixancloud.com/#/board", "_blank");
          }
          
        }
    },
    onNecesitaPremium(){
      this.$swal({
        title: 'Necesitas premium',
        text: '¿Deseas comprar una suscripción premium?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
           this.$router.push({
            name: "suscripcion"
          });
        }
      })
    }


  },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/partials/AppSidebar.vue